export default __webpack_public_path__ + "static/media/plus.1ee29c7a.svg";